const styles = theme => ({
  networkContainer: {
    marginLeft: theme.spacing(4)
  },
  social: {
    padding: `${theme.spacing(4)}px 0`,
    textTransform: "unset",
    color: theme.palette.primary.default
  },
  network: {
    width: "50%",
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  networkTextContainer: {
    width: "50%"
  },
  connectedContainer: {
    width: "50%"
  },

  icon: {
    width: 24,
    height: 24,
    marginRight: theme.spacing(2)
  },
  iconCommingSoon: {
    width: 24,
    height: 24,
    marginRight: theme.spacing(2),
    opacity: 0.4
  },
  networkName: {
    lineHeight: `24px`,
    color: theme.palette.primary.default
  },
  networkNameCommingSoon: {
    lineHeight: `24px`,
    color: theme.palette.primary.default,
    opacity: 0.4
  },
  subtitle: {
    width: 270,
    color: theme.palette.primary.light,
    // marginLeft: 60
    flex: "4"
  },
  button: {
    backgroundColor: "#EFF6EE",
    height: 40,
    width: 120,
    color: [theme.palette.primary.default, "!important"],
    fontFamily: "Poppins",
    textAlign: "center",
    fontSize: 14,
    fontWeight: 700
  },
  buttonConnected: {
    color: [theme.palette.primary.default, "!important"],
    height: 40,
    width: 120,
    fontFamily: "Poppins",
    textAlign: "center",
    fontSize: 14,
    textTransform: "unset"
  },
  buttonsContainer: {
    paddingRight: theme.spacing(2)
  },
  okButton: {
    marginLeft: theme.spacing(1)
  },
  buttonDisconnect: {
    width: 100,
    height: 40,
    marginTop: theme.spacing(3),
    textTransform: "unset",
    color: theme.palette.warning.main,
    marginLeft: theme.spacing(1)
  },
  comingSoomText: {
    color: "#808080"
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/dialogs/Integration/styles.js